package devxertech.com.pages.commons

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextTransform
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.backgroundPosition
import com.varabyte.kobweb.compose.ui.modifiers.backgroundSize
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.textTransform
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Span

@Composable
fun CommonAboutSection(
    breakpoint: Breakpoint,
    firstFont: String,
    secondFont: String,
    firstFontColor: Color? = null,
    secondFontColor: Color? = null,
    description: String,
    imageName: String,
    title: String,
    devModification: Boolean = false

) {
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = if (breakpoint < Breakpoint.MD) 10.px else 50.px)
            .backgroundImage(url(Res.Image.dot_bg))
            .backgroundSize(BackgroundSize.Cover)
            .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
    )
    {
        if (breakpoint <= Breakpoint.MD) {
            Column(
                modifier = Modifier.fillMaxWidth().margin(topBottom = 20.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    title,
                    modifier = Modifier
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(15.px)
                        .textTransform(TextTransform.Uppercase)
                        .margin(topBottom = if (breakpoint == Breakpoint.MD) 7.px else 5.px)
                )
                Row(modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                    horizontalArrangement = Arrangement.Center
                ) {
                    Span (attrs = Modifier
                        .display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).toAttrs()){
                        SpanText(
                            "$firstFont ",
                            modifier = Modifier
                                .color(firstFontColor ?: sitePalette.commonSecondaryButtonColor.rgb)
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(if (devModification) 19.px else 20.px)
                                .textAlign(TextAlign.Center)
                                .fontWeight(FontWeight.Bold)
                        )
                        SpanText(
                            secondFont,
                            modifier = Modifier
                                .color(secondFontColor ?: sitePalette.primary.rgb)
                                .fontFamily(Constants.FONT_FAMILY)
                                .fontSize(if (devModification) 19.px else 20.px)
                                .textAlign(TextAlign.Center)
                                .fontWeight(FontWeight.Bold)
                        )
                    }
                }
                SpanText(
                    description,
                    modifier = Modifier
                        .width(if (breakpoint < Breakpoint.MD) 350.px else 350.px)
                        .width(if (breakpoint == Breakpoint.MD) 650.px else if(window.screen.width < 375) 270.px else 360.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(15.px)
                        .lineHeight(30.px)
                        .textAlign(TextAlign.Justify)
                        .margin(leftRight = 10.px, top = 10.px)
                )
            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceEvenly
        ) {
            Image(
                src = imageName,
                modifier = Modifier.width(if (breakpoint > Breakpoint.LG) 595.px else if (breakpoint == Breakpoint.MD) 550.px else if (window.screen.width < 375) 280.px else  320.px)
                    .height(if (breakpoint > Breakpoint.LG) 386.px else if (breakpoint == Breakpoint.MD) 350.px else 268.px)
                    .margin(
                        top = 20.px,
                        left = if (breakpoint <= Breakpoint.MD) 40.px else 0.px
                    )
            )
            if (breakpoint > Breakpoint.MD) {
                Column(
                    modifier = Modifier.fillMaxWidth(51.percent).margin(topBottom = 40.px),
                    horizontalAlignment = Alignment.CenterHorizontally,
                ) {
                    SpanText(
                        title,
                        modifier = Modifier
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(if (breakpoint == Breakpoint.LG) 15.px else 18.px)
                            .textTransform(TextTransform.Uppercase)
                    )
                    Row(
                        modifier = Modifier.margin(top = 0.px, bottom = 6.px))
                    {
                        Span(attrs = Modifier.textAlign(TextAlign.Center)
                            .margin(left = when (window.screen.width) {
                            in 1441..1600 -> if (devModification) 100.px else 0.px
                            1440 -> if (devModification) 40.px else 0.px
                            1024 -> if (devModification) 0.px else 0.px
                            else -> 0.px }).toAttrs())
                        {
                            SpanText(
                                "$firstFont ",
                                modifier = Modifier
                                    .color(firstFontColor ?: sitePalette.commonSecondaryButtonColor.rgb)
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(if (breakpoint == Breakpoint.LG) 24.px else 35.px)
                                    .fontWeight(FontWeight.Bold)

                            )
                            SpanText(
                                secondFont,
                                modifier = Modifier
                                    .color(secondFontColor ?: sitePalette.primary.rgb)
                                    .fontFamily(Constants.FONT_FAMILY)
                                    .fontSize(if (breakpoint == Breakpoint.LG) 24.px else 35.px)
                                    .fontWeight(FontWeight.Bold)
                            )
                        }
                    }
                    SpanText(
                        description,
                        modifier = Modifier
                            .width(
                                when {
                                    window.screen.width > 1850 -> 1100.px
                                    window.screen.width in 1600 .. 1839-> 900.px
                                    window.screen.width > 1200 -> 700.px
                                    else -> 570.px
                                }
                            )
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(if (breakpoint == Breakpoint.LG) 16.px else 20.px)
                            .margin(left = 40.px)
                            .textAlign(TextAlign.Justify)
                            .lineHeight(1.5.em)
                            .styleModifier {
                                property("display", "-webkit-box")
                                property("-webkit-line-clamp", "7")
                                property("-webkit-box-orient", "vertical")
                                property("overflow", "hidden")
                            }
                    )

                }
            }
        }
    }
}